import { SWRResponse } from 'swr';

import { type SummaryRejectCache, type SummaryResponseCache } from '../lib';

const localStorageProvider = () => {
  // Fallback for SSR — avoid crashing
  if (typeof window === 'undefined') {
    return new Map();
  }

  // On initialization, we restore data from `localStorage` into Map.
  const map = new Map<
    string,
    Omit<SWRResponse<SummaryResponseCache, SummaryRejectCache>, 'mutate'>
  >(JSON.parse(localStorage.getItem('summary-cache') || '[]'));

  // Before unloading the application, we write all data back to `localStorage`.
  window.addEventListener('beforeunload', () => {
    const cache = Array.from(map.entries()) || [];

    if (!cache.length) return;

    const summaryListCache = cache.filter((item) => {
      return item[0].startsWith('/summary');
    });

    if (!summaryListCache.length) return;

    // clear expired cache before unloading
    const withoutExpiredCache = summaryListCache.filter((item) => {
      const { data, error } = item[1];
      const currentDateTimestamp = Date.now();
      const cacheTime = Number(process.env.NEXT_PUBLIC_SUMMARY_CACHE || 0) * 60;
      let cacheAge = 0;

      if (data && data._timestamp) {
        cacheAge = currentDateTimestamp - data._timestamp;

        return cacheAge < cacheTime;
      }

      if (error && error._timestamp) {
        cacheAge = currentDateTimestamp - error._timestamp;

        return cacheAge < cacheTime;
      }

      return false;
    });

    localStorage.setItem('summary-cache', JSON.stringify(withoutExpiredCache));
  });

  // We still use a map for writing and reading for performance.
  return map;
};

export default localStorageProvider;
